import styled, { keyframes } from "styled-components"

const rotate359 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
`

export default styled.div`
  position: relative;
  display: inline-block;
  height: 24px;
  width: 24px;
  vertical-align: middle;
  animation: ${rotate359} 0.6s infinite linear;
  border-radius: 100%;
  z-index: 10;
  border-bottom: 6px solid rgba(150, 150, 150, 0.15);
  border-left: 6px solid rgba(150, 150, 150, 0.15);
  border-right: 6px solid rgba(150, 150, 150, 0.15);
  border-top: 6px solid rgba(150, 150, 150, 0.8);
`



// WEBPACK FOOTER //
// ./src/components/loading-spinner/loading-spinner.component.js